import { Checkbox } from 'antd'

import type { CheckboxProps } from 'antd'

interface GenderFilterProps {
  selectedGender: string
  onChange: (value: string) => void
}

const GENDER_OPTIONS = [
  { value: 'Female', label: 'F - Female / Woman' },
  { value: 'Male', label: 'M - Male / Man' },
  { value: 'Unspecified', label: 'X - Unspecified or another gender identity' },
] as const

export const GenderFilter = ({
  selectedGender,
  onChange,
}: GenderFilterProps) => {
  const handleGenderChange =
    (gender: string): CheckboxProps['onChange'] =>
    (e) => {
      if (e.target.checked) {
        onChange(gender)
      } else {
        onChange('')
      }
    }

  return (
    <div className='flex flex-col gap-3'>
      {GENDER_OPTIONS.map(({ value, label }) => (
        <Checkbox
          key={value}
          id={`${value}`}
          onChange={handleGenderChange(value)}
          checked={selectedGender === value}
        >
          {label}
        </Checkbox>
      ))}
    </div>
  )
}
